<template>
    <v-form class="pb-4">
        <div class="pb-2">
            {{ $t('list_of_additional_fields') }}
            <span class="font-italic"> ({{ $t('list_of_additional_fields_note') }}) </span>
        </div>
        <v-row no-gutters>
            <v-col cols="12" md="10" lg="8">
                <v-row v-for="(listOfCustomFields, index) in distributedItems" :key="index" class="mb-4" no-gutters>
                    <v-col v-for="{key, nameLocalized} in listOfCustomFields" :key="key" cols="12" sm="6" md="4">
                        <v-checkbox v-model="customFields[key]" hide-details :label="nameLocalized" :data-cy="key" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row no-gutters class="gc-4">
            <v-btn data-cy="save" :disabled="isLoading" @click="save">
                {{ $t('save') }}
            </v-btn>
            <v-btn
                class="cancel-btn"
                data-cy="cancel"
                :disabled="isLoading"
                :to="{name: 'supplierProducts', hash: `#${serviceType}`}"
                variant="text"
            >
                {{ $t('cancel') }}
            </v-btn>
        </v-row>
    </v-form>
</template>
<script setup lang="ts">
    import {merge} from 'lodash-es'

    const props = defineProps<{
        contractId: number
        serviceType: string
    }>()

    const isLoading = ref<boolean>(false)
    const visaCustomFieldsList = ref<any>([])
    const customFields = ref<any>({})

    const app = useNuxtApp()
    const {t} = useI18n()

    const distributedItems = ref<any>([])
    const distributionKeys = [
        ['COUNTRY_ID', 'HOME_ADDRESS', 'CITIZENSHIP_ID', 'MARITAL_STATUS', 'PHONE', 'PREVIOUS_LAST_NAMES'],
        ['DATE_OF_BIRTH'],
        ['PASSPORT_NUMBER', 'ISSUE_DATE', 'EXPIRY_DATE'],
        ['POSITION', 'WORK_ADDRESS', 'WORK_PLACE', 'ORGANIZATION_MAIN_ACTIVITY', 'WORK_PHONE'],
    ]

    const distributeItems = (items, distributionKeys) => {
        return distributionKeys.map(keys => {
            return keys.map(key => items.find(item => item.key === key)).filter(Boolean)
        })
    }

    onMounted(async () => {
        EventBus.$on(CHANGE_LOCALE_EVENT, loadOwnVisaCustomFieldsList)
        await loadData()
    })

    onBeforeUnmount(async () => {
        EventBus.$off(CHANGE_LOCALE_EVENT, loadOwnVisaCustomFieldsList)
    })

    async function loadData(): Promise<void> {
        isLoading.value = true
        await Promise.all([loadOwnVisaCustomFieldsList(), loadOwnVisaCustomFields()])
        isLoading.value = false
    }

    async function loadOwnVisaCustomFieldsList(): Promise<void> {
        try {
            visaCustomFieldsList.value = await app.$api.ownVisaCustomFieldsList.get()
            distributedItems.value = distributeItems(visaCustomFieldsList.value, distributionKeys)
        } catch (e) {
            app.$toast.error(t('error_message.load_error'))
        }
    }

    async function loadOwnVisaCustomFields(): Promise<void> {
        try {
            const {customFields: fields} = await app.$api.ownVisaCustomFields.get(props.contractId)

            customFields.value = visaCustomFieldsList.value.reduce((acc, obj) => {
                acc[obj.key] = false
                return acc
            }, {})
            customFields.value = merge(customFields.value, fields)
        } catch (e) {
            app.$toast.error(t('error_message.load_error'))
        }
    }

    const save = async (): Promise<void> => {
        try {
            isLoading.value = true
            await app.$api.ownVisaCustomFields.put(props.contractId, {customFields: customFields.value})
            app.$toast.success(t('success_message.saved_successfully'))
        } catch (e) {
            app.$toast.error(e.msg || e.errors[0].message)
        } finally {
            isLoading.value = false
        }
    }
</script>
